module.exports = __webpack_public_path__ + "b53f27213b154864c405834f251497bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/petsmart_2023_chart.png
// module id = 1716
// module chunks = 0